import { useEndpoint } from '@apparatix/composables';
import { useDocumentStore } from '@apparatix/stores/useDocumentStore';
import { useToast } from 'primevue/usetoast';
import {
  ApiResponseBase,
  FilterDocuments,
  UpdateDocument,
  UpdateDocumentsPayload,
} from '@apparatix/types/Documents';

export const useDocuments = () => {
  const store = useDocumentStore();
  const toast = useToast();

  const filterEndpoint = useEndpoint<ApiResponseBase<FilterDocuments>>({
    url: '/crm/documents/filter',
    type: 'POST',
    successField: 'data',
    onSuccess: response => {
      store.documents = response.data.documents;
      store.documentStatuses = response.data.options.availableDocumentStatuses;
      store.isLoading = false;
    },
    toast: { showOnSuccess: false },
  });

  const updateEndpoint = useEndpoint<UpdateDocument>({
    type: 'PUT',
    url: '/crm/documents',
    successField: 'data',
    onError: (response: UpdateDocument) => {
      toast.add({
        severity: 'error', summary: 'Error', detail: response.error, life: 3000,
      });
    },
    toast: { showOnSuccess: false },
  });

  const updateDocuments = async (payload: UpdateDocumentsPayload) => {
    await updateEndpoint.makeRequest(payload);
  };

  const loadDocumentsHome = (ignoreLoadStatus: boolean = false, status: string = 'active') => {
    store.isLoading = true;
    if (store.documents?.length === 0 || ignoreLoadStatus) {
      filterEndpoint.makeRequest({ filter: { status: status }});
    } else {
      store.isLoading = false;
    }
  };

  return {
    loadDocumentsHome,
    updateDocuments,
  };
};
